import React, { useState, useEffect } from 'react';
import QuestionOverlay from './components/QuestionOverlay';

export default function App() {
  const [questions, setQuestions] = useState([]);
  const [order, setOrder] = useState([]);
  const [idx, setIdx] = useState(0);
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + '/questions.json')
      .then(res => res.json())
      .then(data => {
        setQuestions(data);
        const ids = data.map(q => q.id);
        // Fisher-Yates shuffle
        for (let i = ids.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [ids[i], ids[j]] = [ids[j], ids[i]];
        }
        setOrder(ids);
      });
  }, []);

  const handleNext = () => setIdx((i) => (i + 1) % order.length);
  const handlePrev = () => setIdx((i) => (i - 1 + order.length) % order.length);
  const handleAnswered = () => setCounter((c) => c + 1);

  if (!questions.length) return null;
  const q = questions.find(q => q.id === order[idx]);

  return (
    <QuestionOverlay
      question={q}
      counter={counter}
      currentIndex={idx}
      totalQuestions={order.length}
      onNext={handleNext}
      onPrev={handlePrev}
      onAnswered={handleAnswered}
    />
  );
}
